import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { getDatadogActionName } from "@redotech/redo-web/datadog-action-name";
import { memo } from "react";
import {
  AddressDropdownOption,
  AddressOption,
} from "../create-label-modal-types";

interface IAddressDropdownProps<T extends AddressOption> {
  disabled?: boolean;
  "data-dd-action-name"?: string;
  label: string;
  options: AddressDropdownOption<T>[];
  selectedItem?: AddressDropdownOption<T>;
  onOptionSelected: (item: T) => void;
  placeholder?: string;
  size?: "xs" | "sm" | "md";
}

export const AddressDropdown = memo(function AddressDropdown<
  T extends AddressOption,
>({
  disabled,
  "data-dd-action-name": actionName,
  label,
  options,
  selectedItem,
  onOptionSelected,
  placeholder,
  size = "xs",
}: IAddressDropdownProps<T>) {
  return (
    <RedoSingleSelectDropdownInput
      data-dd-action-name={getDatadogActionName(actionName, "menu_toggle")}
      disabled={disabled}
      fullWidth
      label={label}
      options={options.map((option) => ({
        ...option,
        "data-dd-action-name":
          getDatadogActionName(actionName, "select") ??
          option["data-dd-action-name"],
      }))}
      optionSelected={({ item }) => onOptionSelected(item.value)}
      placeholder={placeholder}
      selectedItem={selectedItem}
      size={size}
    />
  );
});
